/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_NameInputs */



/**
* | output |
* | --- |
* | "Media Name" |
*
* @param {Media_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_name = /** @type {((inputs?: Media_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название медиафайла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del medio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome da mídia")
	return /** @type {LocalizedString} */ ("Media Name")
});